import React from 'react';

const CustomCalendar = ({ selectedDate, setSelectedDate }) => {
    const [showMonthDropdown, setShowMonthDropdown] = React.useState(false);

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

    const generateWeekDates = (date) => {
      const week = [];
      for (let i = 0; i < 7; i++) {
          const day = new Date(date);
          day.setDate(date.getDate() + i);
          week.push(day);
      }
      return week;
    };

    const navigateWeek = (direction) => {
      const newDate = new Date(selectedDate);
      newDate.setDate(selectedDate.getDate() + (direction * 7));
  
      // Prevent going before today
      if (direction === -1 && newDate <= new Date(new Date().setHours(0,0,0,0))) {
          setSelectedDate(new Date(new Date().setHours(0,0,0,0)));
          return;
      }
  
      setSelectedDate(newDate);
    };
    const today = new Date(new Date().setHours(0,0,0,0));
    const currentWeek = generateWeekDates(selectedDate);
    const disablePrev = currentWeek[0].toDateString() === today.toDateString();
    const isYearEnd = currentWeek.some(
      d => d.getMonth() === 11 && d.getDate() === 31
    );
    const disableNext = isYearEnd;

    return (
        <div className="max-w-6xl mx-auto px-1 sm:px-4">
            <div className="relative">
                {/* Horizontal scroll container */}
                <div className="overflow-x-auto pb-4">
                    <div className="min-w-full sm:min-w-[768px]"> {/* Minimum width to maintain desktop spacing */}
                        <div className="flex items-center justify-between gap-1 sm:gap-4">
                            <button
                                onClick={() => navigateWeek(-1)}
                                disabled={disablePrev}
                                className={`w-7 sm:w-10 h-7 sm:h-10 rounded-full border border-[#c66a10] flex items-center justify-center 
                                  transition-colors shrink-0
                                  ${disablePrev 
                                      ? "bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed" 
                                      : "text-[#c66a10] hover:bg-[#c66a10] hover:text-white cursor-pointer"
                                  }`
                              }
                               
                            >
                                <svg
                                    className="w-5 h-5"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>

                            <div className="grid grid-cols-7 gap-1 sm:gap-4 flex-grow">
                                {currentWeek.map((date, index) => (
                                    <div
                                        key={index}
                                        className={`border py-2 sm:p-4  text-center cursor-pointer transition-colors
                                            ${date.toDateString() === selectedDate.toDateString()
                                                ? 'bg-[#c66a10] text-white'
                                                : 'bg-white hover:bg-gray-50'
                                            }
                                            ${index === 0 ? 'rounded-l-lg' : ''}
                                            ${index === 6 ? 'rounded-r-lg' : ''}
                                        `}
                                        onClick={() => setSelectedDate(date)}
                                    >
                                        <div className="text-xs sm:text-sm font-medium mb-1 sm:mb-2">
                                            {weekDays[date.getDay()]}
                                        </div>
                                        <div className="text-xs sm:text-xl">
                                            {date.getDate()}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button
                                onClick={() => navigateWeek(1)}
                                disabled={disableNext}
                                className={`w-7 sm:w-10 h-7 sm:h-10 rounded-full border border-[#c66a10] flex items-center justify-center 
                                  transition-colors shrink-0
                                  ${disableNext 
                                      ? "bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed" 
                                      : "text-[#c66a10] hover:bg-[#c66a10] hover:text-white cursor-pointer"
                                  }`
                              }
                            >
                                <svg
                                    className="w-5 h-5 transform rotate-180"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="relative mt-4">
                    <button
                        onClick={() => setShowMonthDropdown(!showMonthDropdown)}
                        className="text-md font-bold border border-[#c66a10] py-1 px-4 w-full sm:w-48 flex justify-center items-center gap-2 text-[#c66a10]"
                    >
                        {months[selectedDate.getMonth()]}
                        <div className="w-full  flex justify-end">
                          <svg
                            className={`w-4 h-4 transition-transform duration-200 text-left ${
                                 showMonthDropdown ? "rotate-180" : ""
                                      }`}
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                           >
                           <path d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                    </button>

                    {showMonthDropdown && (
                        <div className="absolute z-10 mt-1 w-full sm:w-48 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                            {months.map((month, index) => (
                                <div
                                    key={month}
                                    className="px-4 py-2 cursor-pointer hover:bg-[#0693e3] hover:text-white text-[#c66a10]"
                                    onClick={() => {
                                        const newDate = new Date(selectedDate);
                                        newDate.setMonth(index);
                                        setSelectedDate(newDate);
                                        setShowMonthDropdown(false);
                                    }}
                                >
                                    {month}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomCalendar;